import { authConstants } from '../constants';
import { authRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const authActions = {}//Objeto agrupador de funciones

authActions.Authentication = (authData) => {
  console.log('authData', authData)
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    authRequests.AuthenticationEncripted(authData)//Ejecución de petición al API
    // authRequests.Authentication(authData)//Ejecución de petición al API
    .then(//Respuesta de promesa
      authenticationData => dispatch(success(authenticationData)),//Respuesta correcta del API
      error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
    )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
     return { type: authConstants.AUTH_REQUEST }// => carpeta constants => AuthConstants.js
   }

  function success(authenticationData) { //Respuesta correcta de petición
    return { type: authConstants.AUTH_SUCCESS, authenticationData } // => carpeta constants => AuthConstants.js
  }

  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: authConstants.AUTH_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

authActions.AuthenticationSSO = (authData) => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    authRequests.SSOAuthenticate(authData)//Ejecución de petición al API
    // authRequests.Authentication(authData)//Ejecución de petición al API
    .then(//Respuesta de promesa
      authenticationData => dispatch(success(authenticationData)),//Respuesta correcta del API
      error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
    )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
     return { type: authConstants.AUTH_REQUEST }// => carpeta constants => AuthConstants.js
   }

  function success(authenticationData) { //Respuesta correcta de petición
    return { type: authConstants.AUTH_SUCCESS, authenticationData } // => carpeta constants => AuthConstants.js
  }

  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: authConstants.AUTH_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

authActions.AuthenticationTenant = (authData) => {
  return { type: authConstants.AUTH_UPDATED, authData }
}

authActions.AuthenticationQA = (authData) => {
  return dispatch => {
    console.log('LLEGOAQUI')
    dispatch(request())
    setTimeout(() => {
      dispatch(success(authData))//Respuesta correcta del API
    }, 3000);
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: authConstants.AUTH_REQUEST }// => carpeta constants => AuthConstants.js
  }

  function success(authenticationData) { //Respuesta correcta de petición
    return { type: authConstants.AUTH_SUCCESS, authenticationData } // => carpeta constants => AuthConstants.js
  }

  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: authConstants.AUTH_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

authActions.GetClientIPsWithRefer = () => {

  return dispatch => {
    dispatch(request())
    authRequests.GetClientIPsWithRefer()
      .then(
        clientIPs => dispatch(success(clientIPs)),
        error => (dispatch(failure(error.message)))
      )
  }

  function request() {
    return { type: authConstants.CLIENTIPS_REQUEST }
  }

  function success(clientIPs) {
    return { type: authConstants.CLIENTIPS_SUCCESS, clientIPs }
  }

  function failure(error) {
    return { type: authConstants.CLIENTIPS_FAILURE, error }
  }
}
///Siguiente paso => Crear reducer
